import "./login-loader.css";
import { ThreeDots } from "react-loader-spinner";
const LoginLoader = () => {
  return (
    <div id="login-loader-container">
      <ThreeDots
        height="80"
        width="90"
        radius="9"
        color="#ffde31"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName="login-loader"
      />
    </div>
  );
};
export { LoginLoader };
